/**
 * Created by jv on 18/01/2017.
 */
const utils = require("Sources/utils/utils");

module.exports = class Organisation
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.name = options.name;
    this.identification = options.identification;

    this.address1 = options.address1;
    this.address2 = options.address2;
    this.zip = options.zip;
    this.city = options.city;
    this.country = options.country;
  };
};



// WEBPACK FOOTER //
// ./app/js/models/organisation.js